export const metricFilterConstants = {
    METRIC_FILTER_SET: 'METRIC_FILTER_SET',
    METRIC_FILTER_ADD: 'METRIC_FILTER_ADD',
    METRIC_FILTER_REMOVE: 'METRIC_FILTER_REMOVE',
};
